import {
  DATA_CONNECTOR_GET_STORED_XANO_DATA_BEGIN,
  DATA_CONNECTOR_GET_STORED_XANO_DATA_SUCCESS,
  DATA_CONNECTOR_GET_STORED_XANO_DATA_FAILURE,
  DATA_CONNECTOR_GET_STORED_XANO_DATA_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
export function getStoredXanoData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_STORED_XANO_DATA_BEGIN,
    });
    const { version, projectId, dbUuid } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_STORED_XANO_DATA_SUCCESS,
            data: res.data.getdata,
          });
          resolve(res);
        },

        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_STORED_XANO_DATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissGetStoredXanoDataError() {
  return {
    type: DATA_CONNECTOR_GET_STORED_XANO_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_STORED_XANO_DATA_BEGIN:
      return {
        ...state,
        getStoredXanoDataPending: true,
        getStoredXanoDataError: null,
      };

    case DATA_CONNECTOR_GET_STORED_XANO_DATA_SUCCESS:
      return {
        ...state,
        getStoredXanoDataPending: false,
        getStoredXanoDataError: null,
        xanoStoredData: action.data
      };

    case DATA_CONNECTOR_GET_STORED_XANO_DATA_FAILURE:
      return {
        ...state,
        getStoredXanoDataPending: false,
        getStoredXanoDataError: action.data.error,
      };

    case DATA_CONNECTOR_GET_STORED_XANO_DATA_DISMISS_ERROR:
      return {
        ...state,
        getStoredXanoDataError: null,
      };

    default:
      return state;
  }
}
